@defer (when group().length && form()) {
  @if (isExpandCollapseSectionsEnabled()) {
    <div class="flex items-center gap-sm justify-between mb-2xl">
      <p class="text-lg font-semibold text-neutral-900">
        {{ 'form_builder_request_data_section_title' | transloco }}
      </p>

      <lib-expand-collapse-all
        [(isAllSectionsExpanded)]="isAllSectionsExpanded"
        [parentSectionsContainerId]="'form-builder-container'" />
    </div>
  }

  <div
    class="group_container flex flex-col gap-2xl"
    [formGroup]="form()"
    id="form-builder-container">
    @for (item of group(); track $index; let i = $index) {
      <div
        class="group_item flex flex-col gap-2xl"
        [class.hidden]="
          !(item | showConditionSection: form() : formRevision())
        ">
        @let headerClass =
          item?.updated_field_keys?.length
            ? 'border border-destructive-200!'
            : '';

        <lib-section-header
          [title]="item.name"
          [customClass]="headerClass"
          [isAccordion]="isExpandCollapseSectionsEnabled()"
          [isAccordionOpen]="isAllSectionsExpanded()"
          [contentTemplate]="contentTemplate"
          [badgeTemplate]="badgeTemplate">
          <ng-template #badgeTemplate>
            @if (item?.updated_field_keys?.length) {
              <button
                (click)="changeOriginalUpdatedToggle($index)"
                class="flex items-center py-sm px-lg gap-md">
                <div class="gap-sm flex items-center flex-wrap cursor-pointer">
                  <lib-check-toggle-icon
                    [iconClass]="'size-5 text-neutral-700'" />

                  <p class="text-neutral-700 text-sm font-medium">
                    {{
                      !sectionOriginalToggleArray()[i]
                        ? ('show_original_data_label' | transloco)
                        : ('show_new_data_label' | transloco)
                    }}
                  </p>
                </div>

                <lib-badge
                  [label]="
                    !sectionOriginalToggleArray()[i]
                      ? ('new_original_badge_new_data_label' | transloco)
                      : ('new_original_badge_original_label' | transloco)
                  "
                  [badgeClass]="
                    !sectionOriginalToggleArray()[i]
                      ? ' px-sm text-xs font-medium text-white bg-destructive-500'
                      : ' px-sm text-xs font-medium text-white bg-neutral-900'
                  " />
              </button>
            }
          </ng-template>

          <ng-template #contentTemplate>
            <div
              class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg text-sm font-medium text-neutral-900 items-start">
              @for (
                field of item.fields;
                track $index;
                let fieldIndex = $index
              ) {
                @if (
                  !field.show_condition ||
                  (field.show_condition
                    | showCondition: form() : field : formRevision())
                ) {
                  <div
                    class="relative"
                    [hidden]="field.is_hidden ?? false"
                    [class]="{
                      'col-span-full':
                        (field.type === inputTypesEnum.LOOKUP &&
                          !!field.multiple) ||
                        field.type === inputTypesEnum.GROUP_INPUT_FIELD ||
                        field.type === inputTypesEnum.TABLE_INPUT_FIELD,
                      'col-span-2':
                        field.type ===
                          inputTypesEnum.RICH_EDITOR_DUAL_LANGUAGE_TEXT_AREA_FIELD ||
                        field.type ===
                          inputTypesEnum.DUAL_LANGUAGE_TEXT_AREA_FIELD ||
                        field.type === inputTypesEnum.TEXT_INPUT_FIELD,
                      hidden:
                        item
                        | showHideField
                          : field
                          : sectionOriginalToggleArray()[i],
                    }">
                    @switch (field.type) {
                      @case (inputTypesEnum.GROUP_INPUT_FIELD) {
                        <lib-form-builder-multi-field
                          [field]="field"
                          [form]="form()"
                          [section]="item"
                          [uploadFileUrls]="uploadFileUrls()"
                          [label]="field.label"
                          [equation]="field.properties.equation" />
                      }
                      @case (inputTypesEnum.TABLE_INPUT_FIELD) {
                        <lib-dynamic-table-input
                          [field]="field"
                          [label]="field.label"
                          [form]="form()"
                          [uploadFileUrls]="uploadFileUrls()"
                          [equation]="field.properties.equation"
                          [dependencyFields]="
                            field.properties.dependency_fields ?? []
                          " />
                      }
                      @case (inputTypesEnum.COMPOSITE_FIELD) {
                        <lib-composite-field
                          [field]="field"
                          [form]="form()"
                          [section]="item"
                          [uploadFileUrls]="uploadFileUrls()"
                          [label]="field.label"
                          [equation]="field.properties.equation" />
                      }
                      @default {
                        <lib-form-builder-field
                          [field]="field"
                          [form]="form()"
                          [section]="item"
                          [uploadFileUrls]="uploadFileUrls()"
                          [sectionOriginalToggle]="
                            sectionOriginalToggleArray()[i]
                          " />
                      }
                    }
                  </div>
                }
              }
            </div>
          </ng-template>
        </lib-section-header>
      </div>
    }
  </div>
}
